var _g, _g2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pie_svg__clip0_317_1615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.577 79.266a43.273 43.273 0 0069.489-13.67L57.512 46.762 27.577 79.266z",
    fill: "#4179A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.8 48.027a43.28 43.28 0 00-43.288-43.28V46.76l39.554 18.836a43.125 43.125 0 003.734-17.57z",
    fill: "#BBE7F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.24 48.027a43.162 43.162 0 0013.337 31.24L57.51 46.76 19.468 27.403a43.074 43.074 0 00-5.229 20.624z",
    fill: "#52B2CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.469 27.403l38.043 19.358L41.904 7.666a43.398 43.398 0 00-22.435 19.737z",
    fill: "#4179A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.512 46.76V4.747A43.24 43.24 0 0042.046 7.61l15.466 39.15z",
    fill: "#52B2CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.354 11.075H14.239v2.42h11.115v-2.42z",
    fill: "#EEE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pie_svg__clip1_317_1615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.577 79.266a43.273 43.273 0 0069.489-13.67L57.512 46.762 27.577 79.266z",
    fill: "#4179A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.8 48.027a43.28 43.28 0 00-43.288-43.28V46.76l39.554 18.836a43.125 43.125 0 003.734-17.57z",
    fill: "#3F97BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.24 48.027a43.162 43.162 0 0013.337 31.24L57.51 46.76 19.468 27.403a43.074 43.074 0 00-5.229 20.624z",
    fill: "#BBE7F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.469 27.403l38.043 19.358L41.904 7.666a43.398 43.398 0 00-22.435 19.737z",
    fill: "#76CDE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.512 46.76V4.747A43.24 43.24 0 0042.046 7.61l15.466 39.15z",
    fill: "#52B2CA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.115 55.376H0v2.42h11.115v-2.42zM52.25 0H41.136v2.42H52.25V0zM110 23.733H98.886v2.42H110v-2.42zM78.357 93.348H67.242v2.42h11.115v-2.42z",
    fill: "#EEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pie_svg__clip0_317_1615"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(14.24 4.746)",
    d: "M0 0h86.56v86.56H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pie_svg__clip1_317_1615"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(14.24 4.746)",
    d: "M0 0h86.56v86.56H0z"
  })))));
}
export default SvgPie;